(() => {
  'use strict';

  if (window.LumeAboutOs2) {
    return;
  }

  const instances = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function finalCount(element) {
    element.textContent = element.dataset.laCount || element.textContent;
    element.setAttribute('data-la-done', 'true');
  }

  function animateCount(element, frameIds, timerIds) {
    if (element.dataset.laDone === 'true') return;
    const finalText = element.dataset.laCount || element.textContent;
    const target = Number.parseFloat(finalText);
    if (!Number.isFinite(target)) {
      finalCount(element);
      return;
    }

    element.setAttribute('data-la-done', 'true');
    const suffix = finalText.replace(/^[-+]?\d*\.?\d+/, '');
    const decimals = (String(target).split('.')[1] || '').length;
    const started = performance.now();
    const duration = 900;

    function tick(now) {
      const progress = Math.min((now - started) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      element.textContent = `${(target * eased).toFixed(decimals)}${suffix}`;
      if (progress < 1) {
        const id = requestAnimationFrame(tick);
        frameIds.add(id);
      } else {
        element.textContent = finalText;
      }
    }

    element.textContent = `${(0).toFixed(decimals)}${suffix}`;
    const id = requestAnimationFrame(tick);
    frameIds.add(id);
    const fallbackId = window.setTimeout(() => {
      timerIds.delete(fallbackId);
      if (element.isConnected) finalCount(element);
    }, duration + 150);
    timerIds.add(fallbackId);
  }

  function init(root) {
    if (instances.has(root)) return;

    const reveals = Array.from(root.querySelectorAll('[data-la-anim]'));
    const counters = Array.from(root.querySelectorAll('[data-la-count]'));
    const frameIds = new Set();
    const timerIds = new Set();
    let observer = null;

    function reveal(element) {
      element.classList.add('in');
      if (element.matches('[data-la-count]')) animateCount(element, frameIds, timerIds);
      element.querySelectorAll('[data-la-count]').forEach((counter) => animateCount(counter, frameIds, timerIds));
    }

    if (reduced || !('IntersectionObserver' in window)) {
      reveals.forEach((element) => element.classList.add('in'));
      counters.forEach(finalCount);
    } else {
      root.classList.add('la-motion-ready');
      counters.forEach((counter) => {
        counter.textContent = '0';
        delete counter.dataset.laDone;
      });
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach((element) => observer.observe(element));
    }

    instances.set(root, {
      destroy() {
        if (observer) observer.disconnect();
        frameIds.forEach((id) => cancelAnimationFrame(id));
        frameIds.clear();
        timerIds.forEach((id) => window.clearTimeout(id));
        timerIds.clear();
        root.classList.remove('la-motion-ready');
        reveals.forEach((element) => element.classList.remove('in'));
        counters.forEach(finalCount);
      },
    });
  }

  function scan(scope) {
    const roots = [];
    if (scope.matches && scope.matches('[data-lume-about-os2]')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-lume-about-os2]'));
    roots.forEach(init);
  }

  function unload(scope) {
    const roots = [];
    if (scope.matches && scope.matches('[data-lume-about-os2]')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-lume-about-os2]'));
    roots.forEach((root) => {
      const instance = instances.get(root);
      if (!instance) return;
      instance.destroy();
      instances.delete(root);
    });
  }

  window.LumeAboutOs2 = { scan, unload };
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
})();
